/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { createDataActionHook, IActionContext, IActionInput } from '@msdyn365-commerce/core';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { getProductInfoFromSimpleProduct } from './telemetry.action.helper';

const beforeGetByIds = async (inputs: IActionInput | IActionInput[]) => {
    // placeholder
};

const afterGetByIds = async (
    _inputs: IActionInput | IActionInput[],
    simpleProducts: SimpleProduct | SimpleProduct[],
    actionContext: IActionContext
) => {
    if (!Array.isArray(simpleProducts)) {
        simpleProducts = [simpleProducts];
    }

    simpleProducts.forEach(async product => {
        if (product) {
            product = await Promise.resolve(product);
            const productInfo = getProductInfoFromSimpleProduct(product, actionContext.requestContext);
            actionContext.requestContext.telemetryData[productInfo.productSku] = productInfo;
        }
    });
};

createDataActionHook({
    actionId: '@msdyn365-commerce/retail-proxy/Products/GetByIds',
    postReaderHook: afterGetByIds,
    preReaderHook: beforeGetByIds
});
